import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import useAdAccount from '@hooks/useAdAccount'

type SelectAdChannelButtonProps = {
  adAccountGroupId: number,
}

const SelectAdChannelButton = (props: SelectAdChannelButtonProps) => {
  const { adAccountGroupId } = props

  const {
    callbacks: {
      launchSelectAdChannelModal,
    },
  } = useAdAccount()

  return (
    <Button
      buttonStyle="secondaryEdit"
      icon={<FontAwesomeIcon icon={faPlus} />}
      onClick={() => launchSelectAdChannelModal({ adAccountGroupId })}
      size={['medium', 'small']}
      width={['100%', 'fit-content']}
    >
      Link Ad Account
    </Button>
  )
}

export default SelectAdChannelButton